import { Link } from "react-router-dom";
import { Logo } from "./Navbar";

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-navy-950">
      <div className="px-6 md:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-5 text-sm text-ebg-muted max-w-sm leading-relaxed">
            EBG Group's exclusive franchise partner platform. Every brand owned, operated, and grown by EBG.
          </p>
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow mb-4">Platform</p>
          <ul className="space-y-2.5 text-sm text-ebg-muted">
            <li><Link to="/explore" className="hover:text-gold">Explore Brands</Link></li>
            <li><Link to="/how-it-works" className="hover:text-gold">How It Works</Link></li>
            <li><Link to="/register" className="hover:text-gold">Become a Partner</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow mb-4">Company</p>
          <ul className="space-y-2.5 text-sm text-ebg-muted">
            <li><Link to="/about" className="hover:text-gold">About EBG</Link></li>
            <li><Link to="/faq" className="hover:text-gold">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-4">Disclosure</p>
          <p className="text-xs text-ebg-muted leading-relaxed">
            EBG FinCorp offers franchise partner opportunities within the EBG ecosystem. This is not a fund, scheme, or
            guaranteed-return product. Projections are indicative and subject to due diligence and a signed agreement.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 md:px-12 lg:px-20 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs text-ebg-muted">© {new Date().getFullYear()} EBG Group. All rights reserved.</p>
        <p className="text-xs text-ebg-muted">EBG House, 123 Business District, Bandra (E), Mumbai — 400051</p>
      </div>
    </footer>
  );
}
